import { Checkbox, Inline } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';

const selfTransferStyles = css`
  margin: 30px 0 10px;
`;

interface ExcludeSelfTransferProps {
  handleChange: () => void;
  isChecked?: boolean;
}

const ExcludeSelfTransfer = ({ handleChange, isChecked }: ExcludeSelfTransferProps) => {
  const { t } = useTranslation();

  const excludeSelfTransferLiteral = t(
    'Result.SearchFilters.NumberOfStops.ExcludeSelfTransfer.Label',
  );

  return (
    <Inline alignY="top" className={selfTransferStyles} noWrap spacing={8}>
      <Checkbox checked={isChecked} id="self-transfer-only" onChange={handleChange} value="true" />
      <Checkbox.Label htmlFor="self-transfer-only">{excludeSelfTransferLiteral}</Checkbox.Label>
    </Inline>
  );
};

export default ExcludeSelfTransfer;
